module.exports = __webpack_public_path__ + "img/jiangxi.1df0edc1.png";